<!--
 * @Description:
 * @Version: 1.0.3
 * @Autor: chen wei
 * @Date: 2020-07-13 16:17:14
 * @LastEditors: chen wei
 * @LastEditTime: 2020-07-22 19:24:16
-->
<template>
<div class="listItemBox">
  <van-collapse class="itemBox" v-model="activeNames" @change="setMenu">
    <div class="levelBox" :class="item.children_list.length ? '':'noFirst'" v-for="(item, index) in listData" :key="index">
      <div class="title" v-if="item.children_list.length">{{ item.resource_name }}</div>
      <template v-if="item.children_list.length">
        <van-collapse-item class="menu" :name="sub.resource_id" v-for="(sub, i) in item.children_list" :key="i">
          <template #title>
            <div class="listItemTitle">
              <img :src="require('@/assets/images/light'+ (i % 5 + 1) +'.png')" />
              <span>{{sub.resource_name}}</span>
            </div>
          </template>
          <div class="listItemCont">
            <div class="qusBox" v-if="sub.children_list.length">
              <template v-for="(item, index) in sub.children_list">
                <div class="qusBoxItem" :key="index" v-if="item.type == 1">
                  <div class="levelThreeTitle">
                    {{item.resource_name}}
                  </div>
                  <div v-if="item.children_list.length">
                    <div class="lanItemBox" v-for="(item, index) in item.children_list" :key="index">
                      <div class="lanTitle">
                        <img :src="require('@/assets/images/icon-dian.png')" />
                        <span>{{item.resource_name}}</span>
                      </div>
                      <div class="itemsBox">
                        <div class="item" :class="lan.model_id == record.study_id ? 'now' :(lan.if_study ? 'cur' :'')" @click="goDetail(lan, item)" v-for="(lan, lani) in item.model_list" :key="lani">
                          <div class="nm">{{lan.model_name}}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="itemsBox" v-else>
                    <div class="item" :class="lan.model_id== record.study_id ? 'now' :(lan.if_study ? 'cur' :'')" @click="goDetail(lan, item)" v-for="(lan, lani) in item.model_list" :key="lani">
                      <div class="nm">{{lan.model_name}}</div>
                    </div>
                  </div>
                </div>
                <div class="lanItemBox" :key="index" v-else-if="item.type == 2">
                  <div class="lanTitle">
                    <img :src="require('@/assets/images/icon-dian.png')" />
                    <span>{{item.resource_name}}</span>
                  </div>
                  <div class="itemsBox">
                    <div class="item" :class="lan.model_id== record.study_id ? 'now' :(lan.model_id== record.study_id ? 'now' :(lan.if_study ? 'cur' :''))" @click="goDetail(lan, item)" v-for="(lan, lani) in item.model_list" :key="lani">
                      <div class="nm">{{lan.model_name}}</div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div class="itemsBox" v-else>
              <div class="item" :class="item.model_id== record.study_id ? 'now' : (item.if_study ? 'cur' :'')" @click="goDetail(item, sub)" v-for="(item, index) in sub.model_list" :key="index">
                <div class="nm">{{item.model_name}}</div>
              </div>
            </div>
          </div>
        </van-collapse-item>
      </template>
      <template v-else>
        <van-collapse-item class="menu" :name="sub.resource_id" v-for="(sub, i) in [item]" :key="i">
          <template #title>
            <div class="listItemTitle">
              <img :src="require('@/assets/images/light'+ (index % 5 + 1) +'.png')" />
              <span>{{sub.resource_name}}</span>
            </div>
          </template>
          <div class="listItemCont">
            <div class="qusBox" v-if="sub.children_list.length">
              <template v-for="(item, index) in sub.children_list">
                <div class="qusBoxItem" :key="index" v-if="item.type == 1">
                  <div class="levelThreeTitle">
                    {{item.resource_name}}
                  </div>
                  <div v-if="item.children_list.length">
                    <div class="lanItemBox" v-for="(item, index) in item.children_list" :key="index">
                      <div class="lanTitle">
                        <img :src="require('@/assets/images/icon-dian.png')" />
                        <span>{{item.resource_name}}</span>
                      </div>
                      <div class="itemsBox">
                        <div class="item" :class="lan.model_id == record.study_id ? 'now' :(lan.if_study ? 'cur' :'')" @click="goDetail(lan, item)" v-for="(lan, lani) in item.model_list" :key="lani">
                          <div class="nm">{{lan.model_name}}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="itemsBox" v-else>
                    <div class="item" :class="lan.model_id== record.study_id ? 'now' :(lan.if_study ? 'cur' :'')" @click="goDetail(lan, item)" v-for="(lan, lani) in item.model_list" :key="lani">
                      <div class="nm">{{lan.model_name}}</div>
                    </div>
                  </div>
                </div>
                <div class="lanItemBox" :key="index" v-else-if="item.type == 2">
                  <div class="lanTitle">
                    <img :src="require('@/assets/images/icon-dian.png')" />
                    <span>{{item.resource_name}}</span>
                  </div>
                  <div class="itemsBox">
                    <div class="item" :class="lan.model_id== record.study_id ? 'now' :(lan.model_id== record.study_id ? 'now' :(lan.if_study ? 'cur' :''))" @click="goDetail(lan, item)" v-for="(lan, lani) in item.model_list" :key="lani">
                      <div class="nm">{{lan.model_name}}</div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div class="itemsBox" v-else>
              <div class="item" :class="item.model_id== record.study_id ? 'now' : (item.if_study ? 'cur' :'')" @click="goDetail(item, sub)" v-for="(item, index) in sub.model_list" :key="index">
                <div class="nm">{{item.model_name}}</div>
              </div>
            </div>
          </div>
        </van-collapse-item>
      </template>
    </div>
  </van-collapse>
</div>
</template>

<script>
export default {
  name: 'List',
  props: {
    listData: {
      type: Array,
      default: () => {
        return []
      }
    },
    record: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      activeNames: []
    }
  },
  mounted() {
    const activeNames = localStorage.getItem('openMenu')
    if (activeNames) {
      this.activeNames = JSON.parse(activeNames)
    }
  },
  methods: {
    setMenu(activeNames) {
      localStorage.setItem('openMenu', JSON.stringify(activeNames))
    },
    goDetail(item, parent) {
      const data = {
        item,
        parent
      }
      this.$emit('goDetail', data)
    }
  }
}
</script>

<style lang="less" scoped>
.listItemBox {
  .itemBox {
    &::after {
      display: none;
    }

    .levelBox {
      &:first-child {
        .title {
          padding-top: 10px;
        }
      }

      &.noFirst {
        margin-top: 15px;
      }

      .title {
        max-width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 16px;
        font-weight: bold;
        color: rgba(69, 70, 74, 1);
        // line-height: 16px;
        padding: 18px 0;
        padding-top: 24px;
      }
    }

    .menu {
      width: 100%;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 9px 0px rgba(59, 63, 81, 0.09);
      border-radius: 10px;
      overflow: hidden;
      margin-bottom: 15px;

      &::after {
        display: none;
      }

      /deep/ .van-cell {
        padding: 0 15px;
        height: 56px;
        display: flex;
        align-items: center;

        .van-cell__title {
          overflow: hidden;
        }

        .listItemTitle {
          width: 100%;
          overflow: hidden;
          font-size: 14px;
          font-weight: bold;
          color: rgba(69, 70, 74, 1);
          display: flex;
          align-items: center;

          img {
            width: 21px;
            height: 21px;
            margin-right: 8px;
          }

          span {
            display: block;
            width: 85%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .van-icon {
          color: #74767d;

          &::before {
            content: '\F0A1';
          }
        }
      }

      &:last-child {
        margin-bottom: 0;
      }

      /deep/ .van-collapse-item__content {
        padding: 0 15px;
      }

      .listItemCont {
        .itemsBox {
          display: flex;
          flex-wrap: wrap;
          padding: 20px 5px;
          padding-bottom: 5px;
          box-sizing: border-box;

          .item {
            border: 1px solid rgba(164, 167, 176, 1);
            width: 86px;
            border-radius: 6px;
            height: 30px;
            display: flex;
            align-items: center;
            line-height: normal;
            justify-content: center;
            position: relative;
            background: rgba(255, 255, 255, 1);

            margin-right: 17px;
            margin-bottom: 15px;

            &:nth-child(3n) {
              margin-right: 0;
            }

            &:active {
              background: rgba(222, 252, 232, 1);
              border: 1px solid rgba(107, 213, 154, 1);
              color: #47c981;
            }

            &.cur {
              background: rgba(222, 252, 232, 1);
              border: 1px solid rgba(107, 213, 154, 1);

              .nm {
                color: #47c981 !important;
              }

              &::after {
                content: '';
                width: 30px;
                height: 20px;
                position: absolute;
                right: -15px;
                top: -10px;
                background: url('../../assets/images/icon-studyed.png') no-repeat center;
                background-size: 30px 20px;
              }
            }

            &.now {
              &::after {
                content: '';
                width: 30px;
                height: 20px;
                position: absolute;
                right: -15px;
                top: -10px;
                background: url('../../assets/images/icon-local.png') no-repeat center;
                background-size: 30px 20px;
              }
            }

            .nm {
              max-width: 100%;
              padding: 0 8px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              font-size: 13px;
              color: rgba(69, 70, 74, 1);
              line-height: normal;
            }
          }
        }

        .qusBox {
          padding-top: 13px;
          padding-bottom: 5px;
        }

        .qusBoxItem {
          .levelThreeTitle {
            padding: 0 5px;
            font-size: 14px;
            box-sizing: border-box;
            font-weight: bold;
            color: rgba(69, 70, 74, 1);
            line-height: 20px;
            margin-bottom: 13px;
          }

          .itemsBox {
            padding: 0 5px;
          }
        }

        .lanItemBox {
          .lanTitle {
            padding: 0 5px;
            box-sizing: border-box;
            margin-bottom: 13px;
            font-size: 14px;
            font-weight: bold;
            color: rgba(164, 167, 176, 1);
            line-height: 20px;
            display: flex;
            align-items: center;

            img {
              width: 20px;
              /*px*/
              height: 20px;
              /*px*/
              margin-right: 5px;
              margin-top: -2px;
            }
          }

          .itemsBox {
            padding: 0 5px;
          }
        }
      }
    }
  }
}
</style>
